<template>
  <v-form ref="faixa">
    <v-autocomplete
      v-model="filter.faixaId"
      :items="faixas"
      clearable
      :label="'Faixas'"
      item-text="faixaNome"
      item-value="perguntaFaixaRespostaId"
      :multiple="multiple"
      v-on:change="$emit('onChange', valores)"
      :disabled="disabled"
      hide-details="auto"
      :rules="rules"
      ref="faixa"
      class="faixa"
    >
      <div
        style="display: flex; padding: 0 16px; cursor: pointer"
        slot="prepend-item"
        ripple
        @click="toggle"
        v-if="multiple"
      >
        <div style="margin-right: 32px">
          <v-icon :color="filter.faixaId.length > 0 ? 'indigo darken-4' : ''">{{
            iconMultiple
          }}</v-icon>
        </div>
        <div>Todos</div>
      </div>
      <v-divider slot="prepend-item" class="mt-2" v-if="multiple" />

      <template v-slot:selection="{ item, index }">
        <div v-if="index < maxDisplay || !multiple">
          <span>Pontos: {{ item.faixaPontos }} - {{ item.faixaNome }}</span>
        </div>
        <span v-if="index === maxDisplay && multiple" class="grey--text caption"
          >(+{{ filter.faixaId.length - maxDisplay }} faixas)</span
        >
      </template>

      <template v-slot:item="{ item }">
        <div>
          <span
            ><strong style="font-size: 14px"
              >Pontos: {{ item.faixaPontos }} -
            </strong>
            {{ item.faixaNome }}</span
          >
        </div>
      </template>
      <template slot="no-data"> Nenhuma faixa retornada </template>
    </v-autocomplete>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { cityFaixaAPI } from "@/modules/city/API/CityFaixaAPI";

export default {
  name: "ComboboxFaixa",
  props: {
    filter: {},
    itens: {},
    disabled: false,
    multiple: false,
    perguntaFaixaId: null,
    rules: [],
  },

  data() {
    return {
      maxDisplay: 2,
      valores: [],
      faixas: [],
    };
  },
  computed: {
    ...mapGetters(["user", "isAT"]),
    likesAll() {
      return this.filter.faixaId.length === this.itens.length;
    },
    likesSome() {
      return this.filter.faixaId.length > 0 && !this.itens;
    },
    iconMultiple() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      console.log("perguntaFaixaIdss: ", this.perguntaFaixaId);
      cityFaixaAPI
        .getByPerguntaFaixaId(this.perguntaFaixaId)
        .then(({ data }) => {
          this.faixas = data;
        })
        .catch((err) => {
          console.log("ERROR ComboboxFaixa --> ", err);
          this.$notification.error("Erro ao obter faixas");
        });
    },
    async isValid() {
      return await this.$refs.faixa.validate();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.faixaId = [];
          this.$emit("onChange", this.valores);
        } else {
          this.filter.faixaId = this.itens.slice();
          this.$emit("onChange", this.valores);
        }
      });
    },
  },
};
</script>
<style>
.v-list-item__title {
  white-space: normal;
}

.v-autocomplete__content {
  max-width: 500px;
}

.v-list-item {
  padding: 5px 10px;
}

.v-list-item:not(:last-of-type) {
  border-bottom: 1px solid #c8c3c3;
}
</style>
